import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router";
import { fetchAutoModelList } from "../../../features/settings";
import { setMessageState } from "../../../features/messageInfo";
import { getData, postData, deleteData, putData } from "../../../core/fetchService";
import { MESSAGE_STATUS, DIALOG_USER_STATE } from "../../../core/constants";
import EnhancedTable from "../../components/projectTable";
import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ConfirmDialog from "../../components//confirmDialog";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { CHK_FAIL, withTranslation, GlobalState, linkHeadCell } from "../../../core/utils";
import { useTranslation } from "react-i18next";

import { Typography } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import { withStyles } from "@material-ui/styles";
import CloseBar from "../../components/dialogCloseBar";
import {
  Table, TableBody, TableRow, TableCell,
} from "@material-ui/core";

import IconButton from "../../components/material-ui/IconButton";

import {
  viewStatus, linkStyle, Runnable,
}                                         from "../../components/taskStatus";

import notBackdropClicked from "../../components/helpers/notBackdropClicked";
import Scrollable from '../../components/helpers/scrollable';

function viewAutoStatus(row, cell) {
  return viewStatus(row, cell, {
    s_obj: row,
    percent: row.progress?.percent,
    in_progress: 'Auto-annotation',
  });
}

const styles = (theme) => ({
  dialogField: {
    marginTop: 10
  },
  tooltip: {
    marginRight: 10
  }
});

function EditDialog(props) {
  const { rowId, isClone, autoModelList, classes, onClose } = props;
  const { datasets, models, automodels } = autoModelList;
  const row = (automodels || []).find(am => am._id == rowId) || {};
  const [modelData, setModelData] = useState(row);
  const [overwriteInput, setOverwriteInput] = useState(row.dataset == row.out_dataset);
  const scroll = "paper";
  const { t } = useTranslation();

  const setInputDataset = (event, value) => {
    const dataset = value?._id || null;
    const other = {};
    if (overwriteInput) {
      other.out_dataset = dataset;
    } else {
      if (dataset && dataset == modelData.out_dataset)
        other.out_dataset = null;
    }
    setModelData({ ...modelData, dataset, ...other });
  };

  const changeOverwriteInput = (event) => {
    const ow = event.target.checked;
    const out_dataset = ow ? modelData.dataset : null;
    setOverwriteInput(ow);
    setModelData({ ...modelData, out_dataset});
  };

  return (
    <Fragment>
      <Dialog
        maxWidth="md"
        fullWidth={true}
        open={true}
        onClose={notBackdropClicked(() => onClose(null))}
        scroll={scroll}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <CloseBar
          onClose={() => onClose(null)}
          title={rowId ? isClone ? t('auto.clone_auto') : t('auto.edit_auto') : t('auto.add_auto')}
        />
        <DialogContent dividers={scroll === "paper"} style={{ overflow: "hidden" }}>
          <TextField
            required
            id="autoName"
            size="small"
            className={classes.dialogField}
            label={t("common.name")}
            onChange={(event, value) => setModelData({ ...modelData, name: event.target.value })}
            variant="outlined"
            fullWidth
            defaultValue={row?.name || null}
          />
          <Autocomplete
            key="dataSet"
            id="dataSet"
            size="small"
            options={datasets?.filter(d => d._id != modelData.out_dataset)}
            onChange={setInputDataset}
            getOptionLabel={(option) => option.name}
            value={datasets?.find(d => d._id == modelData.dataset) || null}
            className={classes.dialogField}
            renderInput={(params) => (
              <TextField required {...params} variant="outlined" label={t("auto.dataset")}/>
            )}
          />
          <Autocomplete
            key="model"
            id="model"
            size="small"
            options={models}
            onChange={(event, value) => setModelData({ ...modelData, model: value?._id || null })}
            getOptionLabel={(option) => `${option.name} ${option.status}`}
            defaultValue={(models && models.find(d => d._id === row?.model)) || null}
            className={classes.dialogField}
            renderInput={(params) => (
              <TextField required {...params} variant="outlined" label={t("auto.model")}/>
            )}
          />
          <fieldset style={{
            marginTop: "10px",
            padding: "20px",
            borderRadius: 5,
            borderWidth: 1,
          }}>
            <legend style={{color: "#757575"}}>{t("auto.save_to")}</legend>
            <FormControlLabel
              control={<Checkbox/>}
              label={t("auto.overwrite_input")}
              checked={overwriteInput}
              onChange={changeOverwriteInput}
            />
            {overwriteInput ?
              <span style={{ marginLeft: "50px", color: "red" }}>{t("auto.overwrite_warning")}</span> : null}
            {overwriteInput ? null : <>
              {datasets && <Autocomplete
                key="out_dataset"
                id="out_dataset"
                size="small"
                options={datasets?.filter(d => d._id != modelData.dataset)}
                onChange={(event, value) => setModelData({ ...modelData, out_dataset: value?._id || null })}
                getOptionLabel={(option) => option.name}
                value={datasets?.find(d => d._id == modelData.out_dataset) || null}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label={t("auto.dataset")}/>
                )}
                style={{ marginTop: "20px" }}
              />}
            </>}
            <Typography style={{ margin: (overwriteInput ? 20 : 30)+"px 0 10px" }}>
              {t("auto.dataset_import_settings")}
            </Typography>
            {["update_intents"].map(name =>
            <FormControlLabel
              key={name}
              style={{ marginLeft: "10px", height: "auto", width: "100%" }}
              control={<Checkbox required/>}
              label={t("datasets."+ name)}
              checked={(row && row[name]) || modelData[name] || false}
              onChange={(event, checked) => setModelData({ ...modelData, [name]: checked || false })}
            />
            )}
          </fieldset>
        </DialogContent>
        <DialogActions>
          <Button color="primary" autoFocus
            onClick={() => onClose(null)}
          >
            {t("common.cancel")}
          </Button>
          <Button color="primary"
            onClick={() => onClose(modelData)}
            disabled={!['name','model','dataset','out_dataset'].every(k => modelData[k])}
          >
            {isClone ? t('common.clone') : t('common.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

function ConfirmOutputDialog(props) {
  const { row, automodels, classes, onClose } = props;
  const { datasets } = automodels;
  const [ modelData, setModelData ] = useState(row);
  const [ outputToNew, setOutputToNew ] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const saveAndStart = () => {
    if (outputToNew)
      putData(`/api/automodel/${row._id}/setup_out_dataset`,
        { name: modelData.new_name },
        dispatch,
        () => onClose(row._id)
      );
    else
      onClose(row._id);
  };

  return (
    <Fragment>
      <Dialog
        maxWidth="md"
        fullWidth={true}
        open={true}
        onClose={() => onClose(null)}
        scroll="paper"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <CloseBar onClose={() => onClose(null)} title={t("auto.confirm_output")}/>
        <DialogContent dividers>
          {!outputToNew ?
          <div style={{ margin: "20px" }}>
            <Typography style={{ margin: "20px 0 10px", color: "red" }}>
              <span style={{fontWeight: "bold"}}>{t("common.warning")}!</span> {t("auto.confirm_output_warning")}
            </Typography>
            <Typography style={{}}>
              {t("auto.confirm_output_proposal")}
            </Typography>
          </div> : null }
          <fieldset style={{
            marginTop: "10px",
            padding: "20px",
            borderRadius: 5,
            borderWidth: 1,
          }}>
            <legend style={{color: "#757575"}}>{t("auto.save_to")}</legend>
            <table>
              <tbody>
                <tr>
                  <td>
                    <FormControlLabel
                      control={<Radio/>}
                      label={t("auto.new_dataset")}
                      checked={outputToNew}
                      onChange={() => setOutputToNew(true)}
                    />
                  </td>
                  <td>
                    <TextField
                      required
                      size="small"
                      className={classes.dialogField}
                      onChange={event => setModelData({ new_name: event.target.value })}
                      variant="outlined"
                      value={modelData.new_name || ""}
                      placeholder={t('auto.new_dataset_name')}
                      fullWidth
                      disabled={!outputToNew}
                    />
                  </td>
                  <td>
                  </td>
                </tr>
                <tr>
                  <td>
                    <FormControlLabel
                      control={<Radio/>}
                      label={t("auto.existing_dataset")}
                      checked={!outputToNew}
                      onChange={() => setOutputToNew(false)}
                    />
                  </td>
                  <td>
                    <TextField
                      readOnly
                      key="out_dataset"
                      id="out_dataset"
                      size="small"
                      className={classes.dialogField}
                      variant="outlined"
                      value={datasets?.find(d => d._id == modelData.out_dataset)?.name || ""}
                      fullWidth
                    />
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {!outputToNew ?
                      <span style={{ marginLeft: "50px", color: "red" }}>{t("common.warning")}! {t("auto.overwrite_warning")}</span> : null}
                  </td>
                </tr>
              </tbody>
            </table>
          </fieldset>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose(null)} color="primary" autoFocus>
            {t("common.cancel")}
          </Button>
          <Button onClick={saveAndStart} color="primary">
            {t("common.start")}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

class AutoAnnotation extends React.Component{
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      showModal: null,
      modalContent: null,
      btnNameAgree: null,
      dialogTitle: null,
      editDialogOpen: false,
      editClone: false,
      confirmOutputDialogOpen: false,
      rowId: null,
      modelCloneName: "",
      showConfirmStatus: false,
      modalContentStatus: null,
    };

    this.scrollable = new Scrollable(this);
    this.globalState = new GlobalState(this.getAutoList);
    this.runnable = new Runnable({
      getStatus: a => a?.status,
      statusName: 'Auto-annotation',
      updateStatus: this.getAutoList,
      addActiveStatuses: ['Saving'],
    });
  }

  getAutoList = () => {
    this.props.dispatch(fetchAutoModelList(this.props.projectId));
  };

  componentDidMount() {
    this.scrollable.componentDidMount();
    this.globalState.componentDidMount();
  }

  componentDidUpdate(prevProps) {
    this.runnable.componentDidUpdate(this.props.autoModelList?.automodels);
    this.globalState.componentDidUpdate(prevProps, this.props);
  }

  componentWillUnmount() {
    this.runnable.componentWillUnmount();

    this.abortController.abort();
  }

  abortController = new window.AbortController();

  handleEditRow = (id, name) => () => {
    this.setState({ editDialogOpen: true, rowId: id, editClone: false });
  };

  handleCloneRow = (id, name) => () => {
    this.setState({ editDialogOpen: true, rowId: id, editClone: true });
  };

  handleDeleteRow = (id, name) => () => {
    const { t } = this.props;
    this.setState({
      rowId: id,
      showModal: 'delete',
      dialogTitle: t('auto.delete'),
      modalContent: `${t("auto.delete_auto")}: "${name}"?`,
      btnNameAgree: null,
    });
  };

  handleClickNewRow = () => {
    this.setState({ editDialogOpen: true, rowId: null });
  };

  handleCloseEditDialog = obj => {
    this.setState({ editDialogOpen: false });
    if (!obj)
      return;
    const { dispatch, projectId, t } = this.props;
    const { rowId, editClone } = this.state;

    (rowId
      ? editClone
        ? postData.bind(null, `/api/automodel/copy/${rowId}`, { automodel: { ...obj, project: projectId } })
        : putData.bind(null, `/api/automodel/${rowId}`, { automodel: obj })
      : postData.bind(null, `/api/automodel`, { automodel: { ...obj, project: projectId } })
    )(
      dispatch,
      data => {
        dispatch(setMessageState({
          snackBarMessages: t('auto.auto_saved'),
          snackBarVariant: MESSAGE_STATUS.SUCCESS,
          snackBarState: true,
        }));
        this.getAutoList();
      }
    )
  };

  handleCloseConfirmOutputDialog = (id) => {
    this.setState({ confirmOutputDialogOpen: false});
    if (id) {
      this.getAutoList();
      this.handleStartRow(id);
    }
  };

  handleCloseModal = modalState => {
    const { showModal: action, modelCloneName, rowId } = this.state;
    const { dispatch, autoModelList } = this.props;
    this.setState({ showModal: null });
    if (modalState != DIALOG_USER_STATE.AGREE)
      return;
    if (action == 'stop') {
      this.handleStopRow(rowId);
    } else if (action == 'delete') {
      deleteData(`/api/automodel/${rowId}`, dispatch, data => {
        this.getAutoList();
      });
    } else {
      CHK_FAIL(`unknown model action: ${action}`);
    }
  };

  simpleGet = (url, msg) => {
    getData(url, this.props.dispatch, data => {
      this.props.dispatch(setMessageState({
        snackBarMessages: msg,
        snackBarVariant: MESSAGE_STATUS.SUCCESS,
        snackBarState: true,
      }));
      this.getAutoList();
    });
  };

  handleStartRow = id => {
    this.simpleGet(`/api/automodel/${id}/start`, this.props.t("auto.auto_start"));
  };

  handleStopRow = id => {
    this.simpleGet(`/api/automodel/${id}/stop`, this.props.t("auto.auto_stop"));
  };

  handleAutoStopClick = id => {
    const { t, autoModelList } = this.props;
    this.setState({
      showModal: 'stop',
      rowId: id,
      dialogTitle: t('auto.stop', { name: autoModelList?.automodels.find(am => am._id == id)?.name }),
      modalContent: t('auto.stop_question'),
    });
  };

  openConfirmOutputDialog = id => {
    this.setState({ confirmOutputDialogOpen: true, rowId: id });
  };

  render() {
    const {
      showConfirmStatus, modalContentStatus, 
      editDialogOpen, editClone, confirmOutputDialogOpen, rowId,
      showModal, dialogTitle, modalContent, btnNameAgree,
    } = this.state;
    const { t, autoModelList = [], classes } = this.props;
    const link = linkHeadCell;

    const headCells = [
      { _id: "name",        width: "12%", label: t("common.name"),      textSearch: true },
      { _id: "dataset",     width: "14%", label: t("auto.dataset"),       filterOn: true,   ...link('datasets') },
      { _id: "out_dataset", width: "14%", label: t("auto.out_dataset"),   filterOn: true,   ...link('datasets') },
      { _id: "model",       width: "14%", label: t("auto.model"),         filterOn: true,   ...link('train') },
      { _id: "date",        width: "20%", label: t("auto.date"),      dateTime: true     },
      {
        _id: "status",      width: "20%", label: t("auto.status"),  align: "left", link: row => () =>{
          const modalContentStatus = (
            <Table size="small">
              <TableBody>
                {row.error && <TableRow>
                  <TableCell style={{width: '200px'}}>{t('auto.annotation_status')}</TableCell>
                  <TableCell>{row.error}</TableCell>
                </TableRow>}
                <TableRow>
                  <TableCell>{t('auto.annotation_start')}</TableCell>
                  <TableCell><span style={{textDecoration:'underline'}}>{row.startTestAt}</span></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t('auto.annotation_finish')}</TableCell>
                  <TableCell><span style={{textDecoration:'underline'}}>{row.finishTestAt}</span></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          );
          this.setState({ showConfirmStatus: true, modalContentStatus: modalContentStatus });
        },
        style: linkStyle(row => [row]),
      },
    ];

    return (
      <Fragment>
        {showModal && <ConfirmDialog
          title={dialogTitle}
          content={modalContent}
          closeModal={this.handleCloseModal}
          btnNameAgree={btnNameAgree}
        />}
        {showConfirmStatus &&
        <ConfirmDialog open={showConfirmStatus} content={modalContentStatus} showBtnNameAgree={false}
                       title={t("common.info")} btnNameDisagree={t("common.close")}
                       closeModal={() => this.setState({ showConfirmStatus: false })}/>}
        {editDialogOpen && <EditDialog
          rowId={rowId}
          isClone={rowId && editClone}
          autoModelList={autoModelList}
          classes={classes}
          onClose={this.handleCloseEditDialog}
        />}
        {confirmOutputDialogOpen && <ConfirmOutputDialog
          row={autoModelList.automodels.find(r => r._id == rowId)}
          automodels={autoModelList}
          classes={classes}
          onClose={this.handleCloseConfirmOutputDialog}
        />}
        <EnhancedTable
          id="auto"
          useLocationSearch
          headCells={headCells}
          rows={autoModelList?.automodels?.map(r => {
            return {
              ...r,
              dataset: autoModelList.datasets.find(d => d._id === r.dataset),
              out_dataset: autoModelList.datasets.find(d => d._id === r.out_dataset),
              model: autoModelList.models.find(m => m._id === r.model),
              date: r.status == 'Ready' && r.finishTestAt ? r.finishTestAt : r.updatedAt,
              finishTestAt: r.finishTestAt && new Date(r.finishTestAt).toLocaleString(),
              startTestAt: r.startTestAt && new Date(r.startTestAt).toLocaleString(),
              error: r.error?.json?.message || r.error?.error || r.error || '',
            };
          }) || []}
          viewCell={{ status: viewAutoStatus }}
          toolBarName={t("menu.auto_annotation")}
          newRowTitle={t("auto.add_auto")}
          handleClickNewRow={() => this.handleClickNewRow()}
          handleClickUpdateRow={() => {
            this.getAutoList();
          }}
          customBtns={(name, id) => {
            const isActive = this.runnable.isActive(autoModelList?.automodels, id);
            const ICONS = [
              ['edit',      this.handleEditRow,       EditIcon],
              ['clone',     this.handleCloneRow,      FileCopyIcon],
              ['delete',    this.handleDeleteRow,     DeleteIcon],
            ];
            return (
              <div style={{width: "25%", display: "flex"}}>
                <span>
                  <Button variant="outlined" size="small"
                    onClick={() => !isActive ? this.openConfirmOutputDialog(id, name) : this.handleAutoStopClick(id)}
                  >
                    {t(!isActive ? "common.start" : "common.stop")}
                  </Button>
                </span>
                {ICONS.map(i => <IconButton key={i[0]} title={t("common."+ i[0])} onClick={i[1](id, name)} Icon={i[2]}/>)}
              </div>
            )}}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  projectId: state.settings.projectId,
  autoModelList: state.settings.autoModelList,
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(withTranslation()(AutoAnnotation))));
